import { abilitiesPlugin } from '@casl/vue'
import { useLocalStorage } from '@vueuse/core'
import { ability } from './ability'

export default function (app) {
  // Regresi Modul D: ability array bisa >4KB ter-serialize (mis. role manager
  // 72 permission), lewat batas ukuran cookie browser (~4KB) dan DIAM-DIAM
  // gagal tersimpan. Pindah ke localStorage (limit ~5-10MB) — lihat auth.js.
  const userAbilityRules = useLocalStorage('userAbilityRules', [])

  if (userAbilityRules.value?.length) {
    ability.update(userAbilityRules.value)
  }

  // Register plugin dengan SHARED instance
  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
}
